import * as _ from "lodash";
import { Utils } from "../../common/utils";
import { User } from "../../models/User";
import { BaseInternalView } from "../_BaseViews";

declare var App;
declare var CONFIG;
export class SidepanelView extends BaseInternalView {
    private loggedIn = false;
    private user: User;
    private firstRender = true;
    private ajaxCallMade = false;

    private template = _.template(require("templates/nav/sidepanel.html"));

    constructor(options) {
        super(
            <any>_.extend(options, {
                events: {},
            })
        );

        this.listenTo(this.options.appCollection, "sync", () => {
            this.loggedIn = true;
        });
        this.listenTo(App.Bus, "switch:user", (user) => {
            if (this.user === user) return;
            this.user = user;
            this.loggedIn = true;
            // Only re-render if this is not the initial user load (navigation already rendered with user)
            if (this.firstRender === false) {
                this.render();
            }
        });

        this.listenTo(App.Bus, 'navigation:update', () => {
            this.render(true);
        });
    }

    render(triggeredRender?: boolean) {
        if (this.firstRender || triggeredRender) {
            this.$el.html(this.template());
            this.firstRender = false;
        }
        
        Promise.all([
             Utils.loadAsset(`${window["CONFIG"].portal1.url}/ui25/fragments/common/nav/public/css/left.css`, "css"),
             Utils.loadAsset(`${window["CONFIG"].portal1.url}/ui25/fragments/common/nav/public/js/left.js`, "js"),
        ])
            .then(() => {
                // Only make AJAX call if it hasn't been made yet or if this is a triggered render
                if (!this.ajaxCallMade || triggeredRender) {
                    this.ajaxCallMade = true;
                    $.ajax({
                        url: `${window["CONFIG"].portal1.url}/ui25/fragments/common/nav/left`,
                        method: "GET",
                        beforeSend: function (xhr) {
                            (xhr as any)._source = "leftNavigation";
                        },
                        success: function (response) {
                            if ($("#leftFragmentContainer").is(":empty")) {
                                $("#leftFragmentContainer").html(response);
                            }
                        },
                        error: function (xhr) {
                            console.error("Failed to fetch left navigation fragment:", xhr);
                        }
                    });
                }
            })
            .catch((error) => {
                console.error("An asset failed to load:", error);
            });

        return this;
    }

    remove() {
        return super.remove();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/nav/SidepanelView.ts